export default [
  { count: 166, date: '2020-03-24' },
  { count: 196, date: '2020-03-25' },
  { count: 148, date: '2020-03-26' },
  { count: 320, date: '2020-03-27' },
  { count: 357, date: '2020-03-28' },
  { count: 289, date: '2020-03-29' },
  { count: 586, date: '2020-03-30' },
  { count: 488, date: '2020-04-01' },
  { count: 217, date: '2020-04-02' },
  { count: 396, date: '2020-04-03' },
  { count: 253, date: '2020-04-04' },
  { count: 243, date: '2020-04-05' },
  { count: 103, date: '2020-04-06' },
  { count: 102, date: '2020-04-07' },
  { count: 393, date: '2020-04-08' },
  { count: 449, date: '2020-04-09' },
  { count: 482, date: '2020-04-10' },
  { count: 407, date: '2020-04-11' },
  { count: 118, date: '2020-04-12' },
  { count: 249, date: '2020-04-13' },
  { count: 593, date: '2020-04-14' },
  { count: 467, date: '2020-04-15' },
  { count: 934, date: '2020-04-30' },
  { count: 951, date: '2020-04-16' },
  { count: 405, date: '2020-04-17' },
  { count: 705, date: '2020-04-18' },
  { count: 725, date: '2020-04-19' },
  { count: 1189, date: '2020-04-20' },
  { count: 1169, date: '2020-04-21' },
  { count: 1208, date: '2020-04-22' },
  { count: 1296, date: '2020-04-23' },
  { count: 1439, date: '2020-04-24' },
  { count: 1384, date: '2020-04-25' },
  { count: 1582, date: '2020-04-26' },
  { count: 544, date: '2020-04-27' },
  { count: 602, date: '2020-04-28' },
  { count: 822, date: '2020-04-29' },
  { count: 155, date: '2020-05-11' },
  { count: 459, date: '2020-05-12' },
  { count: 686, date: '2020-05-18' },
  { count: 262, date: '2020-05-17' },
  { count: 590, date: '2020-05-16' },
  { count: 528, date: '2020-05-15' },
  { count: 909, date: '2020-05-14' },
  { count: 945, date: '2020-05-13' },
  { count: 286, date: '2020-05-01' },
  { count: 916, date: '2020-05-02' },
  { count: 380, date: '2020-05-03' },
  { count: 732, date: '2020-05-04' },
  { count: 940, date: '2020-05-05' },
  { count: 745, date: '2020-05-06' },
  { count: 104, date: '2020-05-07' },
  { count: 910, date: '2020-05-08' },
  { count: 1019, date: '2020-05-09' },
  { count: 2789, date: '2020-05-10' },
  { count: 540, date: '2020-05-19' },
  { count: 696, date: '2020-05-20' },
  { count: 966, date: '2020-05-21' },
  { count: 678, date: '2020-05-22' },
  { count: 514, date: '2020-05-23' },
  { count: 865, date: '2020-05-24' },
  { count: 127, date: '2020-05-25' },
  { count: 268, date: '2020-05-26' },
  { count: 724, date: '2020-05-27' },
  { count: 655, date: '2020-05-28' },
  { count: 394, date: '2020-05-29' },
  { count: 562, date: '2020-05-30' },
  { count: 521, date: '2020-05-31' },
  { count: 1015, date: '2020-06-01' },
  { count: 148, date: '2020-06-02' },
  { count: 545, date: '2020-06-03' },
  { count: 140, date: '2020-06-04' },
  { count: 877, date: '2020-06-05' },
  { count: 955, date: '2020-06-06' },
  { count: 873, date: '2020-06-07' },
  { count: 553, date: '2020-06-08' },
  { count: 323, date: '2020-06-09' },
  { count: 943, date: '2020-06-10' },
  { count: 976, date: '2020-06-11' },
  { count: 850, date: '2020-06-12' },
  { count: 900, date: '2020-06-13' },
  { count: 564, date: '2020-06-14' },
  { count: 803, date: '2020-06-15' },
  { count: 1066, date: '2020-06-16' },
  { count: 1595, date: '2020-06-17' },
  { count: 3991, date: '2020-06-18' },
  { count: 571, date: '2020-06-19' },
  { count: 395, date: '2020-06-20' },
  { count: 529, date: '2020-06-21' },
  { count: 5197, date: '2020-06-22' },
  { count: 4508, date: '2020-06-23' },
  { count: 882, date: '2020-06-24' },
  { count: 618, date: '2020-06-25' },
  { count: 180, date: '2020-06-26' },
  { count: 722, date: '2020-06-27' },
  { count: 706, date: '2020-06-28' },
  { count: 1073, date: '2020-06-29' },
  { count: 772, date: '2020-06-30' },
  { count: 244, date: '2020-07-01' },
  { count: 1068, date: '2020-07-02' },
  { count: 866, date: '2020-07-03' },
  { count: 1455, date: '2020-07-04' },
  { count: 465, date: '2020-07-05' },
  { count: 266, date: '2020-07-06' },
  { count: 1002, date: '2020-07-07' },
  { count: 848, date: '2020-07-08' },
  { count: 729, date: '2020-07-09' },
  { count: 504, date: '2020-07-10' },
  { count: 1188, date: '2020-07-11' },
  { count: 560, date: '2020-07-12' },
  { count: 904, date: '2020-07-13' },
  { count: 305, date: '2020-07-14' },
  { count: 399, date: '2020-07-15' },
  { count: 921, date: '2020-07-16' },
  { count: 132, date: '2020-07-17' },
  { count: 166, date: '2020-07-18' },
  { count: 746, date: '2020-07-19' },
  { count: 597, date: '2020-07-20' }
];
